import { render } from "./CummulativePaymentPosition.vue?vue&type=template&id=4671280c&scoped=true"
import script from "./CummulativePaymentPosition.vue?vue&type=script&lang=js"
export * from "./CummulativePaymentPosition.vue?vue&type=script&lang=js"

import "./CummulativePaymentPosition.vue?vue&type=style&index=0&id=4671280c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4671280c"]])

export default __exports__